import { Flex } from 'foundations-components/components/Flex';
import { useTableSelector } from '../../redux/reduxHooks';
import BulkActionsContainer from '../../selection/components/BulkActionsContainer';
import { getShouldShowBulkActionsContainer } from '../../selection/redux/selectionSlice';
import { TABLE_TOP_BAR_HEIGHT } from '../constants/sizes';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function TableTopBar({
  alternateHeaderLeftSlot,
  BulkActionsComponent,
  headerLeftSlot,
  headerRightSlot,
  isBulkActionsRedesignEnabled,
  showSelectQuery,
  totalRowCount
}) {
  const shouldShowBulkActions = useTableSelector(getShouldShowBulkActionsContainer);
  const shouldOnlyShowBulkActions = shouldShowBulkActions && isBulkActionsRedesignEnabled;
  return /*#__PURE__*/_jsx(Flex, {
    alignItems: "center",
    backgroundColor: "fill-field-default",
    blockSize: TABLE_TOP_BAR_HEIGHT,
    borderBlockEndWidth: "0",
    borderColor: "border-core-default",
    borderStyle: "solid",
    borderWidth: "100",
    "data-test-id": "table-top-bar",
    flexBasis: TABLE_TOP_BAR_HEIGHT,
    inlineSize: "100%",
    justifyContent: isBulkActionsRedesignEnabled ? 'space-between' : 'start',
    children: shouldOnlyShowBulkActions ? /*#__PURE__*/_jsx(BulkActionsContainer, {
      BulkActionsComponent: BulkActionsComponent,
      totalRowCount: totalRowCount,
      isBulkActionsRedesignEnabled: isBulkActionsRedesignEnabled,
      showSelectQuery: showSelectQuery
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [headerLeftSlot, !shouldShowBulkActions && alternateHeaderLeftSlot, shouldShowBulkActions && /*#__PURE__*/_jsx(BulkActionsContainer, {
        BulkActionsComponent: BulkActionsComponent,
        totalRowCount: totalRowCount,
        isBulkActionsRedesignEnabled: isBulkActionsRedesignEnabled,
        showSelectQuery: showSelectQuery
      }), /*#__PURE__*/_jsx("div", {
        className: "m-left-auto",
        children: headerRightSlot
      })]
    })
  });
}
export default TableTopBar;